<template>
  <el-dialog
    title="历史记录"
    :visible.sync="isShowHistoryDialog"
    :append-to-body="true"
    :before-close="onChangeHistory"
    :close-on-click-modal='false'
    custom-class="mainDialog">
    <div class="data-list-box">
      <el-table
        :data="tableData"
        border
        max-height="250"
        border
        style="width:100%"
      >
        <el-table-column
          prop="unitPrice"
          label="单价"
          min-width="50%">
        </el-table-column>
        <el-table-column
          prop="updatedTime"
          label="操作时间"
          min-width="50%">
          <template slot-scope="scope">
            {{scope.row.updatedTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div v-if="total>20" class="pagination-box" style="text-align:right;">
      <el-pagination layout="total,prev, pager, next" @current-change="onPageChange" :current-page.sync="page" :page-size="20" :total="total">
      </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onChangeHistory">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    props:['isShowHistoryDialog','historyUnitPrices'],
    data(){
      return {
        tableData:[],
        total:0,
        page:1
      }
    },
    watch: {
      historyUnitPrices:{
        handler:function(val){
          this.tableData = val?val.slice(0,20):[]
          this.total = val?val.length:0
        },
        immediate: true
      }
    },
    methods:{
      onPageChange(val) {
        this.tableData = this.historyUnitPrices.slice((val-1)*20,(val-1)*20+20)
      },
      onChangeHistory(){
        this.$emit('onChangeHistory')
      }
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/global/historyUnitPrices.vue